import { EmptyState } from "@/command/ccUi";

export default function Placeholder({ title, hint }) {
  return (
    <div data-testid={`cc-page-${(title || "").toLowerCase()}`}>
      <h1 className="display text-2xl md:text-3xl font-light text-ink">{title}</h1>
      <p className="text-subtle mt-1 mb-8">Module overview</p>
      <EmptyState title="No data available yet"
        hint={hint || "This module is part of a later ORAYA Command Center phase. The foundation, realtime, RBAC and audit are already live."} />
    </div>
  );
}
